export default __webpack_public_path__ + "static/media/architecture-4.51407551.webp";